module.exports = __webpack_public_path__ + "static/media/ptl-overview-preview.159e038e.jpg";